var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UpdateSave',_vm._b({attrs:{"maxWidth":750,"itemKey":"Project","fetchData":_vm.fetchData,"setTitle":_vm.setTitle,"setItemForm":_vm.setItemForm,"updateData":_vm.updateData},on:{"onUpdate":(response) => _vm.$emit('onUpdateNote', response)},scopedSlots:_vm._u([{key:"default",fn:function({
        errors,
        ItemForm
      }){return [_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('vue-editor',{model:{value:(ItemForm.note),callback:function ($$v) {_vm.$set(ItemForm, "note", $$v)},expression:"ItemForm.note"}})],1)],1)]}}])},'UpdateSave',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }